import './SkipLink.css';

const SkipLink = () => (
  <a className="skip-link" href="#main">
    Skip to content
  </a>
);

export default SkipLink;
